/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many dice can I roll?`)
};

const es_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos dados puedo tirar?`)
};

const de_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Würfel kann ich werfen?`)
};

const nl_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met hoeveel dobbelstenen kan ik gooien?`)
};

const fr_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de dés puis-je lancer ?`)
};

const it_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti dadi posso lanciare?`)
};

const pt_br2_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos dados posso rolar?`)
};

const pt_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos dados posso lançar?`)
};

const ja_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何個までサイコロを振れますか?`)
};

const zh_dice_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我最多能掷多少个骰子？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_q2", locale)
	if (locale === "en") return en_dice_faq_q2(inputs)
	if (locale === "es") return es_dice_faq_q2(inputs)
	if (locale === "de") return de_dice_faq_q2(inputs)
	if (locale === "nl") return nl_dice_faq_q2(inputs)
	if (locale === "fr") return fr_dice_faq_q2(inputs)
	if (locale === "it") return it_dice_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_q2(inputs)
	if (locale === "pt") return pt_dice_faq_q2(inputs)
	if (locale === "ja") return ja_dice_faq_q2(inputs)
	return zh_dice_faq_q2(inputs)
};